import $ from 'jquery';

(function () {

  $('.btn').on('click', function() {
    $(this).addClass('btn--active');
  });

})();
